import {
  getAdaptiveSkillTaxonomyValue,
  parseAdaptiveTaxonomyId,
} from '@revelio/iso-utility';

import type { SelectionList } from '../../../../shared/selection-lists/types';
import { DEFAULT_SKILL_TAXONOMY_ID } from '../contexts/defaultFilters';
import type { CustomSkillTaxonomySelection } from '../definitions/skillTaxonomy';
import type { TreeFilter } from '../types/filters';
import { extractRicsSelections } from '../utils/extractRicsSelections';

export { DEFAULT_SKILL_TAXONOMY_ID };

// Extracts the relevant selections from the company filter and delegates the
// heavy-lifting to `getAdaptiveSkillTaxonomyValue`. The adaptive skill taxonomy
// is derived from this inside the reducer — see `deriveAdaptiveTaxonomies`.
export function getSkillTaxonomyValue(
  companyFilter: TreeFilter,
  ricsK400List: SelectionList<'rics_k400'>
): CustomSkillTaxonomySelection {
  const taxonomyId = getAdaptiveSkillTaxonomyValue({
    ricsK400List,
    ricsSelections: extractRicsSelections(companyFilter),
  });

  return { taxonomyId: parseAdaptiveTaxonomyId(taxonomyId, 'custom_skill') };
}
